/**
 * Spinner.tsx — simple animated SVG spinner
 */

interface Props {
  size?: number;
  color?: string;
}

export default function Spinner({ size = 18, color = "#ffffff" }: Props) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      style={{ animation: "spin 0.75s linear infinite", display: "inline-block", verticalAlign: "middle" }}
      aria-hidden="true"
    >
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      <circle
        cx="12" cy="12" r="10"
        stroke={color} strokeOpacity="0.25" strokeWidth="3" fill="none"
      />
      <path
        d="M12 2a10 10 0 0 1 10 10"
        stroke={color} strokeWidth="3" fill="none" strokeLinecap="round"
      />
    </svg>
  );
}
